import React from "react";
import "./UserActionComponent.scss";
import PropTypes from "prop-types";

var isFirstReturnStroke = false;
function UserActionComponent({
  text,
  placeholder,
  enableAutoFocus,
  handleOnEnterPress,
}) {
  const handleOnKeyDown = (e) => {
    if (e.key === "Enter" && handleOnEnterPress) {
      e.preventDefault();
      if (isFirstReturnStroke) {
        isFirstReturnStroke = false;
        handleOnEnterPress();
      } else {
        isFirstReturnStroke = true;
      }
    } else {
      isFirstReturnStroke = false;
    }
  };

  return (
    <article className="user-action">
      <textarea
        placeholder={placeholder}
        autoFocus={enableAutoFocus}
        defaultValue={text}
        rows="5"
        onKeyDown={handleOnKeyDown}
      ></textarea>
    </article>
  );
}

UserActionComponent.propTypes = {
  text: PropTypes.string,
  placeholder: PropTypes.string,
  enableAutoFocus: PropTypes.bool,
  handleOnEnterPress: PropTypes.func,
};

export default UserActionComponent;
